import { Inject, Injectable } from "@angular/core";
import { SessionService } from "../session/session.service";

@Injectable({ providedIn: 'root' })
export class PermissionsConfig {

  private module: number;

  constructor(@Inject('module') module: number) {
    this.module = module;
  }

  /**
   * Comprueba si un ususario tiene acceso a un permiso de un controlador
   */
  public HasRolePermission(sessionService: SessionService, permission: number): boolean {
    if (sessionService.isLoggedIn()) {
        //Obtenemos los permisos del usuario en sesion
        var listPermissions = sessionService.user.ListPermissions;
        if (listPermissions == null) {
          return false;
        }else{
          //Comprobamos si tiene permisos
          var result = listPermissions.find(item => item.module == this.module && item.permissions.find(p => p == permission));
          return result != null;
        }    
    }else{
        return false;
    }
  }
}

export interface IPermissionItem {
  controller?: string;
  action: string;
  roles?: number[]
}

